<template>
  <div>
    <label class="font-weight-bold my-3">
      <span class="text-sm bg-green text-white py-1 px-2 rounded">必須</span> <span :style="delLine">ご</span>出欠
    </label>
    <div class="row form-group">
      <div class="col">
        <button
          type="button"
          :class="{col: true,btn: true, 'btn-outline-primary': true, 'd-block': true, 'px-2':true, 'w-100': true, 'rounded': true, 'border': true,  'border-dark': true, 'text-gray-500': status != 'entry', 'bg-gray-300': status != 'entry', 'text-white': status == 'entry', 'bg-black': status == 'entry' }"
          @click="setEntry">
          <i class="mio" v-if="status === 'entry'"> check </i>
          <span :style="delLine">ご</span><span :style="status === 'entry' ? {} : delLine">出席</span>
        </button>
      </div>
      <div class="col">
        <button
          type="button"
          :class="{col: true, btn:true, 'btn-outline-primary': true, 'd-block': true, 'px-2':true, 'w-100': true, 'rounded': true, 'border': true, 'border-dark': true, 'text-gray-500': status != 'pass', 'bg-gray-300': status != 'pass', 'text-white': status == 'pass', 'bg-black': status == 'pass' }"
          @click="setPass">
          <i class="mio" v-if="status === 'pass'"> check </i>
          <span :style="delLine">ご</span><span :style="status === 'pass' ? {} : delLine">欠席</span>
        </button>
      </div>
    </div>
    <div class="pt-1 pb-1 initialism text-gray-500 text-center">どちらかを選択してください</div>
    <label class="font-weight-bold my-3">
      <span class="text-sm bg-green text-white py-1 px-2 rounded">必須</span> <span :style="delLine">ご</span>芳名
    </label>
    <div class="row">
      <div class="col">
        <input type="text" class="form-control rounded bg-light" placeholder='山田' v-model="name_family" />
      </div>
      <div class="col">
        <input type="text" class="form-control rounded bg-light" placeholder='太郎' v-model="name_given" />
      </div>
    </div>
    <label class="font-weight-bold my-3">
      <span class="text-sm bg-green text-white py-1 px-2 rounded">必須</span> <span :style="delLine">ご</span>芳名(フリガナ)
    </label>
    <div class="row">
      <div class="col">
        <input type="text" class="form-control rounded bg-light" placeholder='ヤマダ' v-model="name_family_kana" />
      </div>
      <div class="col">
        <input type="text" class="form-control rounded bg-light" placeholder='タロウ' v-model="name_given_kana" />
      </div>
    </div>
    <label class="font-weight-bold my-3">
      <span class="text-sm bg-green text-white py-1 px-2 rounded">必須</span> <span :style="delLine">お</span>電話番号
    </label>
    <input type="text" class="form-control rounded bg-light" placeholder='090-1234-5678' v-model="telephone" />
    <small class="text-info" v-if="!telephoneMobile">
      お電話番号は携帯電話番号を記入していただきますと当日の緊急連絡先として使用することができます。
    </small>
    <label class="font-weight-bold mt-3">
      <span class="text-sm bg-green text-white py-1 px-2 rounded">必須</span> 食物アレルギー
    </label>
    <br>
    <small class="text-gray-500">アレルギーがない場合は、なしとご記入ください</small>
    <textarea class="form-control mt-3 rounded bg-light" placeholder='なし' v-model="food_allergy" />      
    <label class="font-weight-bold my-3">
      <span class="text-sm bg-gray-300 text-gray-500 py-1 px-2 rounded">任意</span> メッセージ
    </label>
    <textarea class="form-control rounded bg-light" v-model="note" />
    <button
      type="button"
      class="btn btn-green btn-lg d-block w-100 my-5"
      :disabled="!inputed"
      @click="submit">
      <div v-if="guest.status !== 'entry' && guest.status !== 'pass' ">
        <i class="mio"> send </i>
        送信
      </div>
      <div v-else-if="guest.status === 'entry'">
        出席連絡済
      </div>
      <div v-else-if="guest.status === 'pass'">
        欠席連絡済
      </div>
    </button>
  </div>
</template>

<script>
const KEYS = ['status', 'name_family', 'name_family_kana', 'name_given', 'name_given_kana', 'telephone', 'food_allergy', 'note']

export default {
  props: ['guest'],
  data() {
    const data = {}
    for (let key of KEYS) {
      data[key] = null
    }
    return data
  },
  mounted() {
    for (let key of KEYS) {
      this[key] = this.guest[key]
    }
  },
  methods: {
    setEntry() {
      this.status = 'entry'
      this.note = 'ご結婚おめでとうございます お招きいただきありがとうございます 喜んで出席させていただきます'
    },
    setPass() {
      this.status =  'pass'
    },
    submit() {
      const values = {}
      for (let key of KEYS) {
        values[key] = this[key]
      }
      this.$emit('submit', { guest: values })
    }
  },
  computed: {
    inputed() {
      return this.status !== 'accessed' && this.telephone && this.name_given && this.name_given_kana
    },
    delLine() {
      return this.status === 'accessed' ?
        {} :
        { 'text-decoration': 'line-through' }
    },
    telephoneMobile() {
      return !this.telephone || /^0[789]0/.test(this.telephone)
    }
  }
}
</script>

<style scoped>
</style>
